import { render, staticRenderFns } from "./ChatBoxWidget.vue?vue&type=template&id=773d2f8b&scoped=true&"
import script from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
export * from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxWidget.vue?vue&type=style&index=0&id=773d2f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d2f8b",
  null
  
)

export default component.exports